import React, { useState } from 'react';
import { Button } from '@components/ui/button';
import { Input } from '@components/ui/input';
import { Copy } from 'lucide-react';

const CollaborationStep = ({ onNext, onBack, formData, canGoBack }) => {
  const [emails, setEmails] = useState(formData.collaborators || ['', '', '']);

  const handleEmailChange = (index, value) => {
    const newEmails = [...emails];
    newEmails[index] = value;
    setEmails(newEmails);
  };

  const handleSkip = () => {
    onNext({ collaborators: [] });
  };

  const handleContinue = () => {
    const validEmails = emails.filter((email) => email.trim() !== '');
    onNext({ collaborators: validEmails });
  };

  return (
    <div className="space-y-8 animate-fade-in max-w-xl mx-auto">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">Who do you want to learn with?</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          You can invite your friends to learn, create, and collaborate with you.
        </p>
      </div>

      <div className="space-y-6 max-w-md mx-auto">
        <div className="space-y-4">
          {emails.map((email, index) => (
            <Input
              key={index}
              type="email"
              placeholder={index === 0 ? 'beaver@mit.edu' : index === 1 ? 'tree@stanford.edu' : 'peter@uci.edu'}
              value={email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
              className="bg-secondary border-border text-foreground placeholder:text-muted-foreground"
            />
          ))}
        </div>

        <div className="flex items-center space-x-2 text-sm text-primary cursor-pointer hover:text-primary/80 transition-colors">
          <Copy className="w-4 h-4" />
          <span>Copy link to invite</span>
        </div>
      </div>

      <div className="flex justify-between pt-8">
        <div className="flex space-x-4">
          {canGoBack && (
            <Button variant="outline" onClick={onBack} className="px-8">
              Back
            </Button>
          )}
          <Button variant="outline" onClick={handleSkip} className="px-8">
            Skip
          </Button>
        </div>
        <Button onClick={handleContinue} className="px-8">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default CollaborationStep;
